// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vT6i","top":"styles_top__1E28I","left":"styles_left__1UHxx","description":"styles_description__38i-R"};